<div class="sidebar">
  <div class="tab-wrapper">
    <div class="tab" routerLink="/tabs/home" routerLinkActive="active">
      <ion-icon aria-hidden="true" name="home-sharp"></ion-icon>
      <div>Home</div>
    </div>
    <div class="tab" routerLink="/tabs/browse" routerLinkActive="active">
      <ion-icon aria-hidden="true" name="search"></ion-icon>
      <div>Browse</div>
    </div>
    <div class="tab" routerLink="/tabs/my-scripts" routerLinkActive="active" #addScriptTab>
      <ion-icon class="normal-icon" aria-hidden="true" src="assets/icons/add-script.svg" />
      <ion-icon class="active-icon" aria-hidden="true" src="assets/icons/add-script-active.svg" />
      <div>My Scripts</div>
    </div>
    <div class="tab" routerLink="/tabs/orders" routerLinkActive="active">
      @if (activeOrderCount() > 0) {
        <div class="counter"><span>{{ activeOrderCount() }}</span></div>
      }
      <ion-icon aria-hidden="true" name="cart"></ion-icon>
      <div>Orders</div>
    </div>
    <div class="tab" routerLink="/tabs/account" routerLinkActive="active">
      <ion-icon name="person"></ion-icon>
      <div>Account</div>
    </div>
  </div>
  <div class="bottom-container">
    <app-download-app />
  </div>
</div>